import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import GoogleAnalytics from '../GoogleAnalytics'

interface LayoutProps {
  children?: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen w-full flex flex-col bg-white">
      <GoogleAnalytics />

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-1 w-full">{children ?? <Outlet />}</main>

      {/* Footer */}
      <Footer />
    </div>
  )
}
